const useApiBaseUrl = () => {
  return window.__RUNTIME_CONFIG__.REACT_APP_API_BASE_URL;
};

export default useApiBaseUrl;
